// Template-owned learner UI only. Authored activity text and shared catalog
// strings are localized by the host, and must never be passed through this map.
const russian = {
  'Correct!': 'Верно!',
  'Use 10-rods in Tens and 1-rods in Ones.': 'В столбце десятков используй палочки длиной 10, а в столбце единиц — палочки длиной 1.',
  'Use 10-rods in Tens and 1-rods in Ones, with at most nine in each column. Leave space between rods.': 'В столбец десятков клади палочки длиной 10, а в столбец единиц — длиной 1. В каждом столбце может быть не больше девяти палочек. Палочки не должны перекрывать друг друга.',
  'Select a rod and click the workspace, or drag it there, to build the requested arrangement. Then click the check button. Double-click to rotate a rod; drag it to the trash to remove it.': 'Выбери палочку и щёлкни по доске или перетащи палочку на доску. Расположи палочки по заданию и нажми кнопку проверки. Дважды щёлкни по палочке, чтобы повернуть её; перетащи в корзину, чтобы убрать.',
  'Try again.': 'Попробуй ещё раз.',
  'Here is the expected arrangement.': 'Вот правильное расположение палочек.',
  'Correct! Your rods match the expected arrangement.': 'Верно! Палочки расположены правильно.',
  'Try again. Check the rod lengths, alignment, and orientation.': 'Попробуй ещё раз. Проверь длину палочек, их расположение и направление.',
  'Type your answer in the box below the canvas, then click “Check answer”. You can use rods to help you work it out.': 'Введи ответ в поле под доской и нажми «Проверить ответ». Палочки помогут тебе посчитать.',
  'Select an answer to the right of the question. You can use rods to help you decide.': 'Выбери ответ справа от вопроса. Палочки помогут тебе посчитать.',
  'Multiple-choice question': 'Вопрос с выбором ответа',
  'Drag rods onto the canvas to build the requested arrangement, then click the check button. Double-click to rotate a rod; drag it to the trash to remove it.': 'Перетащи палочки на доску и расположи их по заданию. Затем нажми кнопку проверки. Дважды щёлкни по палочке, чтобы повернуть её. Чтобы убрать палочку, перетащи её в корзину.',
  'Your answer': 'Твой ответ',
  'Type your answer': 'Введи ответ',
  'Check answer': 'Проверить ответ',
  'Check rods': 'Проверить палочки',
  'Show answer': 'Показать ответ',
  'Reset workspace': 'Очистить доску',
  'Delete selected rod': 'Убрать выбранную палочку',
  'Previous': 'Назад',
  'Next': 'Далее',
  'Finish': 'Завершить',
  'Back to authoring': 'Вернуться к редактированию',
  'Go': 'Пуск',
  'Stop': 'Пауза',
  'Speak': 'Слушать',
  'Stop speaking': 'Приостановить озвучивание',
  'Listen': 'Слушать',
  'Tens': 'Десятки',
  'Ones': 'Единицы',
  'None': 'Без действия',
  'Hide equation': 'Скрыть равенство',
  'Addition equation': 'Равенство со сложением',
  'Subtraction equation': 'Равенство с вычитанием',
  'Multiplication equation': 'Равенство с умножением',
  'Division equation': 'Равенство с делением',
  'Addition': 'Сложение',
  'Subtraction': 'Вычитание',
  'Multiplication': 'Умножение',
  'Division': 'Деление',
  'Rod workspace': 'Доска для палочек',
  'Drop a rod here to remove it': 'Отпусти палочку здесь, чтобы убрать её',
  'Drag a rod here to remove it': 'Перетащи палочку сюда, чтобы убрать её',
  'Place rods in rows to build an equation.': 'Расположи палочки рядами, чтобы составить равенство.',
  'Use equal rods in the first row.': 'В первом ряду используй палочки одинаковой длины.',
  'Audio could not play. Use Go to retry.': 'Не удалось воспроизвести звук. Нажми «Пуск», чтобы попробовать ещё раз.',
  'Audio could not play. Use Speak to retry.': 'Не удалось воспроизвести звук. Нажми «Слушать», чтобы попробовать ещё раз.',
  'Audio could not play.': 'Не удалось воспроизвести звук.',
};

const spanish = {
  'Use 10-rods in Tens and 1-rods in Ones.': 'Usa regletas del 10 en Decenas y regletas del 1 en Unidades.',
  'Use 10-rods in Tens and 1-rods in Ones, with at most nine in each column. Leave space between rods.': 'Usa regletas del 10 en Decenas y regletas del 1 en Unidades, hasta nueve en cada columna. Deja espacio entre las regletas.',
  'Tens': 'Decenas', 'Ones': 'Unidades', 'None': 'Ninguna',
  'Audio could not play. Use Go to retry.': 'No se pudo reproducir el audio. Pulsa Iniciar para intentarlo de nuevo.',
  'Hide equation': 'Ocultar la ecuación',
  'Addition equation': 'Ecuación de suma', 'Subtraction equation': 'Ecuación de resta',
  'Multiplication equation': 'Ecuación de multiplicación', 'Division equation': 'Ecuación de división',
  'Addition': 'Suma', 'Subtraction': 'Resta', 'Multiplication': 'Multiplicación', 'Division': 'División',
  'Previous': 'Anterior', 'Next': 'Siguiente', 'Finish': 'Finalizar',
  'Rod workspace': 'Área de trabajo con regletas',
};
export function mathRodsLearnerText(text, language = 'en') {
  const locale = String(language).toLowerCase().split('-')[0];
  if (locale === 'es') return spanish[text] || text
    .replace(/^Add (\d+) rod$/, 'Añadir regleta del $1')
    .replace(/^Drag (\d+) rod$/, 'Arrastrar regleta del $1')
    .replace(/^(\d+) rod — drag into the workspace$/, 'Regleta del $1: arrástrala al área de trabajo')
    .replace(/^(\d+ ÷ \d+ = \d+) remainder (\d+)$/, '$1, resto $2');
  if (locale !== 'ru') return text;
  if (Object.hasOwn(russian, text)) return russian[text];
  return text
    .replace(/^Segment (\d+) of (\d+)$/, 'Часть $1 из $2')
    .replace(/^Add (\d+) rod$/, 'Добавить палочку длиной $1')
    .replace(/^Drag (\d+) rod$/, 'Перетащи палочку длиной $1')
    .replace(/^(\d+) rod — drag into the workspace$/, 'Палочка длиной $1 — перетащи её на доску')
    .replace(/^(\d+) rod — drag into workspace$/, 'Палочка длиной $1 — перетащи на доску')
    .replace(/^(\d+) rod, column (\d+), row (\d+)$/, 'Палочка длиной $1, столбец $2, ряд $3')
    .replace(/^Listen to answer (.+)$/, 'Послушать ответ: $1')
    .replace(/^(\d+ ÷ \d+ = \d+) remainder (\d+)$/, '$1, остаток $2');
}

// The UI follows the selected activity language; captions identify the actual
// recording language. A text translation does not translate recorded speech.
export function mathRodsNarrationLabels(language = 'en', mediaLanguage = language) {
  const spanish = mediaLanguage === 'es';
  const labels = {
    summary: spanish ? 'Ejemplo narrado' : 'Narrated example',
    description: spanish ? 'Este video muestra otro ejemplo de la operación. Después, continúa con los segmentos de esta actividad.' : 'This video demonstrates the operation. Afterwards, continue with this activity’s segments.',
    video: spanish ? 'Ejemplo narrado de regletas' : 'Narrated Math Rods example',
    audioOnly: spanish ? 'Solo audio' : 'Audio only',
    audio: spanish ? 'Narración del ejemplo' : 'Example narration',
    transcript: spanish ? 'Leer la narración' : 'Read the narration',
    captionLanguage: spanish ? 'es' : 'en',
    captionLabel: spanish ? 'Español' : 'English',
  };
  if (language !== 'ru') return labels;
  return {
    ...labels,
    summary: mediaLanguage === 'en' ? 'Пример с озвучкой на английском' : mediaLanguage === 'es' ? 'Пример с озвучкой на испанском' : 'Пример с озвучкой',
    description: 'В этом видео показан пример выполнения задания. Затем продолжай работу с частями этого упражнения.',
    video: 'Пример с математическими палочками',
    audioOnly: 'Только звук',
    audio: 'Озвучивание примера',
    transcript: 'Прочитать текст озвучивания',
    captionLanguage: mediaLanguage,
    captionLabel: mediaLanguage === 'ru' ? 'Русский' : labels.captionLabel,
  };
}
